import httpClient from "@plugins/http";

interface RecipientRequestData {
  recipientType: string;
  length: number;
  start: number;
}

const getBadges = (requestData) => {
  return httpClient.get(`/apis/user-digital-badge/list?`, {
    params: requestData,
  });
};

const getBadge = (digitalBadgeId) => {
  return httpClient.get(`/apis/user-digital-badge/get/${digitalBadgeId}`);
};

const awardDigitalBadge = (digitalBadgeUuid, requestPayload) => {
  return httpClient.post(`/apis/user-digital-badge/award/${digitalBadgeUuid}`, requestPayload);
};

const getAwardedRecipients = (digitalBadgeUuid: string, requestData: RecipientRequestData) => {
  return httpClient.get(`/apis/user-digital-badge/recipients/${digitalBadgeUuid}`, {
    params: requestData,
  });
};

const getBadgeJsonObject = (jsonUrl) => {
  const timeStamp = Date.now();
  jsonUrl = jsonUrl + `?&t=${timeStamp}`;

  return httpClient.get(jsonUrl, {
    headers: {
      Accept: "application/json",
    },
    withCredentials: true, // This allows cookies to be sent
  });
};

export default {
  getBadges,
  getBadge,
  awardDigitalBadge,
  getAwardedRecipients,
  getBadgeJsonObject,
};
